import React from 'react';
import Lottie from 'react-lottie';

const LottieWrapper = ({
  animationData,
  width = 150,
  height = 150,
  loop = true,
  autoplay = true,
  preserveAspectRatio = 'xMidYMid slice',
  ...rest
}) => {
  const defaultOptions = {
    loop:loop,
    autoplay,
    animationData,
    rendererSettings: {
      preserveAspectRatio,
    },
  };

  return <Lottie options={defaultOptions} width={width} height={height} {...rest} />;
};

export default LottieWrapper;
